<template>
  <modal :show="show" header-classes="justify-content-center" @close="handleClose()">
    <div class="modal-body">
      <div class="modal-split">
        <p style="font-size:16px; margin-top:0px">
          Are you sure you want to remove the end date?
        </p>
        <p style="font-size:16px; margin-top:0px">
          <strong>If the end date was in the past,
            this will generate all attendances from the end date to the current date.</strong>
        </p>
      </div>
    </div>
    <template slot="footer">
      <p-button @click="handleClose()">
        Cancel
      </p-button>
      <p-button
        type="danger"
        @click="reopenStudy()"
      >
        Remove/Reopen
      </p-button>
    </template>
  </modal>
</template>

<script>
import {
    mapState, mapGetters, vuex
} from 'vuex';
import modal from '../UIComponents/Modal';

export default {
    name: 'ConfirmBSReopenModal',
    components: {
        modal
    },
    data() {
        return {
            namespace: 'BibleStudies'
        };
    },
    props: {
        show: Boolean
    },
    computed: {
        ...mapState({
            error: (state) => state.BibleStudies.error,
        }),
    },
    methods: {
        reopenStudy() {
            this.$store.dispatch(`${this.namespace}/reopenBibleStudy`,
                { bibleStudyId: this.$route.params.id });
            this.handleClose();
        },
        handleClose() {
            this.$emit('close');
        },
    },
};
</script>
  <style scoped>
  .btn.btn-danger {
    margin: 2%;
  }
  </style>
